import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { trackInAnalytics } from '@alfa-bank/newclick-alfa-metrics';
import { ErrorViewDesktop } from '@alfa-bank/newclick-composite-components/error-view/desktop';
import { useAsyncAtom } from '@alfa-bank/newclick-core/hooks';

import { Gap } from '@alfalab/core-components/gap';

import { moneyPoolDataAtom } from '../../../shared/atoms/money-pool-data/atom';
import { Loader } from '../../../shared/components/loader';
import { MoneyPoolInfo } from '../../../shared/components/money-pool-info';
import { ProgressInfo } from '../../../shared/components/progress-info';
import { getFormatedAmount } from '../../../shared/utils/get-formated-amount';
import { Layout } from '../../components/layout';
import { TransferButton } from '../../components/transfer-button';

export const MoneyPoolPage = () => {
    const { publicId = '' } = useParams<{ publicId: string }>();

    const {
        getMoneyPoolDataRetry,
        getMoneyPoolDataData,
        getMoneyPoolDataError,
        getMoneyPoolDataLoading,
    } = useAsyncAtom(moneyPoolDataAtom, { fetchInitialLoad: true, params: { publicId } });

    useEffect(() => {
        if (getMoneyPoolDataData) {
            const { categoryName, dueDate, goalAmount, totalSum, comment } = getMoneyPoolDataData;

            trackInAnalytics('OPEN_MONEY_POOL_LANDING', {
                publicId,
                categoryName,
                dueDate,
                totalSum: getFormatedAmount(totalSum),
                goalSum: goalAmount && getFormatedAmount(goalAmount),
                comment,
            });
        }
    }, [getMoneyPoolDataData, publicId]);

    if (getMoneyPoolDataLoading) {
        return (
            <Layout background={true}>
                <Loader />
            </Layout>
        );
    }

    if (getMoneyPoolDataError) {
        return (
            <Layout>
                <Gap size={128} />
                <ErrorViewDesktop
                    onClick={getMoneyPoolDataRetry}
                    type={getMoneyPoolDataError.errorType}
                />
            </Layout>
        );
    }

    if (!getMoneyPoolDataData) {
        return null;
    }

    const { status } = getMoneyPoolDataData;

    return (
        <Layout topContent={<ProgressInfo />}>
            <MoneyPoolInfo />
            {status === 'ACTIVE' && <TransferButton />}
        </Layout>
    );
};
